import { useReveal } from "@/lib/useReveal";

const steps = [
  {
    n: "01",
    title: "Brief & feasibility",
    body: "We listen to the design intent, interrogate the brief and stress-test feasibility against budget and programme.",
  },
  {
    n: "02",
    title: "Design coordination",
    body: "Trades, M&E and joinery details resolved up-front. The AI engine starts modelling the programme.",
  },
  {
    n: "03",
    title: "Workshop & site",
    body: "Manufacture runs in parallel with site mobilisation. Live updates feed the project engine continuously.",
  },
  {
    n: "04",
    title: "Handover",
    body: "Snag-led closeout, O&M documentation, and an aftercare relationship that lasts beyond practical completion.",
  },
];

export const Process = () => {
  const ref = useReveal();
  return (
    <section
      id="process"
      ref={ref}
      data-testid="process-section"
      className="relative py-24 lg:py-32 bg-[#F5F5F4]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14 lg:mb-20">
          <div className="col-span-12 lg:col-span-3 reveal">
            <div className="overline">06 — Process</div>
          </div>
          <div className="col-span-12 lg:col-span-9 reveal">
            <h2
              data-testid="process-heading"
              className="font-display text-3xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]"
            >
              A measured way of working.
            </h2>
            <p className="mt-6 max-w-2xl text-black/65 leading-relaxed">
              The discipline of an architectural practice, paired with the speed of
              a vertically integrated contractor.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-px bg-black/10 reveal">
          {steps.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="col-span-12 sm:col-span-6 lg:col-span-3 bg-[#F5F5F4] p-7 lg:p-8 min-h-[240px] flex flex-col justify-between"
            >
              <div className="font-display text-5xl lg:text-6xl text-black/15 tracking-tight">
                {s.n}
              </div>
              <div>
                <div className="font-display text-xl lg:text-2xl">{s.title}</div>
                <p className="text-sm text-black/65 mt-3 leading-relaxed">
                  {s.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
